/** Short display labels for dashboard charts (full text stays in tooltips). */

export function shortenOsLabel(label) {
  if (!label) return 'Unknown'
  let text = String(label)
    .replace(/^Microsoft\s+/i, '')
    .replace(/\s+for\s+.+$/i, '')
    .trim()
  if (text.length > 36) {
    return `${text.slice(0, 34)}…`
  }
  return text
}

export function formatCategoryLabel(label) {
  if (!label) return 'Unknown'
  const text = String(label).replace(/_/g, ' ')
  return text.charAt(0).toUpperCase() + text.slice(1)
}

export function maxLabelLength(data, key = 'label') {
  if (!data?.length) return 0
  return Math.max(...data.map((d) => String(d[key] ?? '').length))
}
